module.exports = __webpack_public_path__ + "img/新重庆横排LOGO(彩色)@2x.38283f30.png";